import { useEffect } from "react"
import { useParams } from 'react-router-dom'

import { useFormikContext } from "formik"

import styles from "../../../styles/Form.module.css"

export default function IdEnterprise({ field, block, index }) {
  const { type } = useParams()
  const isEnterprise = type === 'enterprise'

  const formik = useFormikContext()

  useEffect(() => {
      return formik.setFieldValue(field.field_name, isEnterprise)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return (
    <div className={styles.hidden} style={{ order: index }}>
      <input
        type="hidden"
        name={field.field_name}
        value={formik.values[field.field_name]}
      />
    </div>
  )
}
